export function getElementPhpTemplate({
  namespace,
  phpClassName,
  uiIcon,
  tag,
  tagOptions,
  tagControlPath,
  name,
  className,
  category,
  badge,
  defaultProperties,
  defaultChildrenElements,
  designControls,
  contentControls,
  settingsControls,
  dependencies,
  settings,
  addPanelRules,
  actions,
  nestingRules,
  spacingBars,
  attributes,
  experimental,
  order,
  dynamicPropertyPaths,
  additionalClasses,
  projectManagement,
  propertyPathsToWhitelistInFlatProps,
  propertyPathsToSsrElementWhenValueChanges
}: {
  namespace: string;
  phpClassName: string;
  uiIcon: string;
  tag: string;
  tagOptions: string;
  tagControlPath: string;
  name: string;
  className: string;
  category: string;
  badge: string;
  defaultProperties: string;
  defaultChildrenElements: string;
  designControls: string;
  contentControls: string;
  settingsControls: string;
  dependencies: string;
  settings: string;
  addPanelRules: string;
  actions: string;
  nestingRules: string;
  spacingBars: string;
  attributes: string;
  experimental: string;
  order: string;
  dynamicPropertyPaths: string;
  additionalClasses: string;
  projectManagement: string;
  propertyPathsToWhitelistInFlatProps: string;
  propertyPathsToSsrElementWhenValueChanges: string;
}) {
  return `<?php

namespace ${namespace};

use function Breakdance\\Elements\\c;
use function Breakdance\\Elements\\PresetSections\\getPresetSection;


\\Breakdance\\ElementStudio\\registerElementForEditing(
    "${namespace}\\\\${phpClassName}",
    \\Breakdance\\Util\\getdirectoryPathRelativeToPluginFolder(__DIR__)
);

class ${phpClassName} extends \\Breakdance\\Elements\\Element
{
    static function uiIcon()
    {
        return '${uiIcon}';
    }

    static function tag()
    {
        return '${tag}';
    }

    static function tagOptions()
    {
        return ${tagOptions};
    }

    static function tagControlPath()
    {
        return ${tagControlPath};
    }

    static function name()
    {
        return '${name}';
    }

    static function className()
    {
        return '${className}';
    }

    static function category()
    {
        return '${category}';
    }

    static function badge()
    {
        return ${badge};
    }

    static function slug()
    {
        return get_class();
    }

    static function template()
    {
        return file_get_contents(__DIR__ . '/html.twig');
    }

    static function defaultCss()
    {
        return file_get_contents(__DIR__ . '/default.css');
    }

    static function defaultProperties()
    {
        return ${defaultProperties};
    }

    static function defaultChildren()
    {
        return ${defaultChildrenElements};
    }

    static function cssTemplate()
    {
        $template = file_get_contents(__DIR__ . '/css.twig');
        return $template;
    }

    static function designControls()
    {
        return ${designControls};
    }

    static function contentControls()
    {
        return ${contentControls};
    }

    static function settingsControls()
    {
        return ${settingsControls};
    }

    static function dependencies()
    {
        return ${dependencies};
    }

    static function settings()
    {
        return ${settings};
    }

    static function addPanelRules()
    {
        return ${addPanelRules};
    }

    static public function actions()
    {
        return ${actions};
    }

    static function nestingRule()
    {
        return ${nestingRules};
    }

    static function spacingBars()
    {
        return ${spacingBars};
    }

    static function attributes()
    {
        return ${attributes};
    }

    static function experimental()
    {
        return ${experimental};
    }

    static function order()
    {
        return ${order};
    }

    static function dynamicPropertyPaths()
    {
        return ${dynamicPropertyPaths};
    }

    static function additionalClasses()
    {
        return ${additionalClasses};
    }

    static function projectManagement()
    {
        return ${projectManagement};
    }

    static function propertyPathsToWhitelistInFlatProps()
    {
        return ${propertyPathsToWhitelistInFlatProps};
    }

    static function propertyPathsToSsrElementWhenValueChanges()
    {
        return ${propertyPathsToSsrElementWhenValueChanges};
    }
}
`;
}
